"use client";

import React from "react";

export function Gallery10() {
  return (
    /* bg-wood-cream = tvoje krémová, text-black = černý text */
    <section id="relume" className="bg-wood-cream text-black font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        <div className="mb-12 text-center md:mb-18 lg:mb-20">
          {/* Nadpis - font Gelasio, velikost 56px na desktopu */}
          <h2 className="mb-5 text-[36px] font-bold font-serif leading-[1.2] md:mb-6 md:text-[56px]">
            Naše práce
          </h2>
        </div>
        
        {/* Sloupce s fotkami - přidal jsem zaoblené rohy a jemný efekt při najetí myší */}
        <div className="gap-8 space-y-8 md:columns-3">
          <div className="block w-full overflow-hidden rounded-lg">
            <img
              src="img/Placeholder Image 1.png"
              alt="Ukázka tesařské práce 1"
              className="w-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="block w-full overflow-hidden rounded-lg">
            <img
              src="img/Placeholder Image 2.png"
              alt="Ukázka tesařské práce 2"
              className="w-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="block w-full overflow-hidden rounded-lg">
            <img
              src="img/Placeholder Image 3.png"
              alt="Ukázka tesařské práce 3"
              className="w-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="block w-full overflow-hidden rounded-lg">
            <img
              src="img/Placeholder Image 4.png"
              alt="Ukázka tesařské práce 4"
              className="w-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="block w-full overflow-hidden rounded-lg">
            <img
              src="img/Placeholder Image 5.png"
              alt="Ukázka tesařské práce 5"
              className="w-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="block w-full overflow-hidden rounded-lg">
            <img
              src="img/Placeholder Image 6.png"
              alt="Ukázka tesařské práce 6"
              className="w-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="block w-full overflow-hidden rounded-lg">
            <img
              src="img/Placeholder Image 6.png"
              alt="Ukázka tesařské práce 7"
              className="w-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
        </div>
      </div>
    </section>
  );
}